<template>
  <div class="bonuses">
    <div class="item__row item__ac bonuses__logo">
      <i class="mdi mdi-gift mr-2"></i>
    </div>

    <div class="item__column statistics item__100">
      <p class="mb-2 statistics__title">Статистика на год</p>

      <div class="item__row item__ac statistics__list" v-if="showLoader">
        <div class="item__statistic" v-for="statistic in statistics" :key="statistic.id">
          <p class="item__mb item__statistic__month">{{ statistic.month }}</p>
          <p class="item__statistic__freq">+{{ statistic.freq }} ₸</p>
        </div>
      </div>
      <div class="item__row" v-else>
        <v-skeleton-loader
          v-for="(i, j_index) in 7"
          :key="j_index"
          type="actions"
          class="mr-2"
        ></v-skeleton-loader>
      </div>
    </div>
    <div class="bonuses__search__area  item__row item__ac">
      <input
        v-model="searchText"
        @input="searchBonus"
        placeholder="Поиск клиента"
        class="bonuses__search"
      />
      <i class="mdi mdi-magnify"></i>
    </div>

    <p class="bonuses__result">
      <span class="bonuses__result__text mr-2">Количество карт</span>
      <span>{{ bonuses.length }} </span>
      <br />
    </p>

    <div class="item__column" v-if="showLoader">
      <div
        class="item__column bonuses__list mb-2"
        v-for="(bonus, index) in bonuses"
        :key="index"
      >
        <div class="item__row item__ac bonuses__right__actions">
          <i class="mdi mdi-account-edit-outline" @click="getBonus(bonus.id)"></i>
          <p class="bonuses__count item__abs">
            <span>{{ bonus.pay_date.split(" ").length / 2 }}</span>
          </p>
        </div>

        <p class="bonuses__list__name mr-2 mb-3">
          <i class="mdi mdi-account mr-1"></i>{{ bonus.name }}
        </p>
        <p class="bonuses__list__phone mr-2">{{ formatPhoneNumber(bonus.phone) }}</p>
        <p class="mr-2">{{ bonus.card_number }}</p>

        <p class="mr-10 bonuses__amount">
          <b>+{{ bonus.bonus }} ₸</b>
        </p>

        <p>Даты совершения покупки:</p>
        <div class="mr-2 item__column bonuses__list__date" v-if="bonus.pay_date">
          <p
            v-for="(date, d) in bonus.pay_date.split(' ')"
            :key="d"
            v-html="formatDate(date)"
          ></p>
        </div>
      </div>
    </div>

    <div class="item__column mb-2" v-else>
      <v-skeleton-loader
        class="mb-2"
        v-for="(jj, index) in 5"
        :key="index"
        type="article"
      ></v-skeleton-loader>
    </div>

    <v-dialog v-model="updateDialog" max-width="500">
      <v-card>
        <!-- <div class="green__row green__ac green__jb green__100 ">
                        <p>Форма</p>
                        <p @click="dialogApplication=false">Закрыть</p>
                  </div> -->

        <form
          action=""
          @submit.prevent="updateBonusForm"
          class="green__column item__column item_ac green__message"
          style="padding: 20px"
        >
          <div class="green__column green__input">
            <p>Имя</p>
            <v-text-field
              v-model="name"
              label="Номер карты"
              required
              outlined
            ></v-text-field>
          </div>
<!--          <div class="green__column green__input">-->
<!--            <p>Номер карты</p>-->
<!--            <v-text-field-->
<!--              v-model="card_number"-->
<!--              label="Номер карты"-->
<!--              required-->
<!--              outlined-->
<!--            ></v-text-field>-->
<!--          </div>-->
          <div class="green__column green__input">
            <p>Номер телефона</p>
            <v-text-field
              v-model="phone"
              label="Номер телефона"
              required
              outlined
            ></v-text-field>
          </div>
          <div class="green__column green__input">
            <p>Цена</p>
            <v-text-field
              v-model="price"
              label="Цена"
              required
              outlined
            ></v-text-field>
          </div>
          <button type="submit" class="button">Отправить</button>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: ["bonusesList"],
  data() {
    return {
      showLoader: false,
      statistics: [],
      bonuses: [],
      updateDialog: false,
      phone: "",
      card_number: "",
      price: "",
      searchText: "",
      bonus: "",
      name: "",
    };
  },

  methods: {
    getGuest() {
      this.$http
        .get("/year/bonus" + this.searchText, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.statistics = res.data;
        });
    },
    formatPhoneNumber(phoneNumberString) {
      let filter = "";
      if (phoneNumberString.slice(0, 1) == "8") {
        filter = phoneNumberString.replace("8", "");
      }

      return (
        "8 " +
        filter.replace(/\D+/g, "").replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4")
      );
    },
    formatDate(d) {
      let array = [];
      array.push(d.split(" ")[0]);
      let dates = [];
      for (let index = 0; index < array.length; index++) {
        if (array[index].includes("-")) {
          array[index] =
            array[index].split("-")[2] +
            "." +
            array[index].split("-")[1] +
            "." +
            array[index].split("-")[0];
          dates.push(array[index]);
          continue;
        }
      }
      return this.datePrint(dates);
    },
    datePrint(array) {
      let res = "";
      for (let index = 0; index < array.length; index++) {
        res = "‣ " + res + array[index] + "<br>";
      }
      return res;
    },
    searchBonus() {
      this.$http
        .get("/search/bonus?search=" + this.searchText, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.bonuses = res.data;
        });
    },
    updateBonusForm() {
      let data = {
        id: this.bonus.id,
        name: this.name,
        card_number: this.card_number,
        phone: this.phone,
        price: this.price,
      };
      this.$http
        .post("/update/bonus", data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.card_number = "";
          this.phone = "";
          this.price = "";
          this.$toast.open({
            message: res.data.message,
            type: "success",
            position: "bottom",
            duration: 5000,
            queue: true,
          });
          this.updateDialog = false;
          this.getBonuses();
        });
    },
    deleteBonus(id) {
      confirm("Удалить запись?");

      let data = {
        id: id,
      };
      this.$http
        .post("/delete/bonus", data, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        })
        .then((res) => {
          this.$toast.open({
            message: res.data.message,
            type: "success",
            position: "bottom",
            duration: 5000,
            queue: true,
          });
          this.getBonuses();
        });
    },
    getBonuses() {
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
      };
      this.bonus = "";
      this.$http.get("/get/bonuses", config).then((res) => {
        this.bonuses = res.data;

        setTimeout((this.showLoader = true), 5000);
      });
    },
    getBonus(id) {
      this.updateDialog = true;
      const config = {
        headers: { Authorization: `Bearer ${localStorage.getItem("access_token")}` },
      };
      this.bonus = "";
      this.$http.get("/get/bonus/by/id?id=" + id, config).then((res) => {
        this.name = res.data.name;
        this.bonus = res.data;
        this.phone = res.data.phone;
        this.price = res.data.bonus;

        console.log(res.data);

        this.name = res.data.name;
        this.card_number = res.data.card_number;
      });
    },
  },
  computed: {},
  watch: {
    bonusesList(val) {
      this.bonuses = val;
    },
    searchText(val) {
      if (val) {
        this.searchBonus();
      } else {
        this.getBonuses();
      }
    },
  },
  mounted() {
    this.getGuest();
    this.getBonuses();
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}
.pointer:hover {
  opacity: 0.8px;
}

.statistics {
  margin-top: 20px;
  .statistics__list {
    overflow-x: auto;
  }
  .statistics__list::-webkit-scrollbar {
    height: 1px;
  }
  .statistics__list::-webkit-scrollbar-track {
    border-radius: 2px;
    background-color: transparent;
  }
  .statistics__list::-webkit-scrollbar-thumb {
    background-color: transparent;
    border-radius: 2px;
  }
  .statistics__title {
    font-size: 22px;
    color: white;
  }
  .item__statistic {
    margin-right: 20px;
    background-image: linear-gradient(
      to right,
      #253532,
      #1e363d,
      #273345,
      #3c2e43,
      #4c2934
    );
    min-width: 150px;
    padding: 20px;
    border-radius: 20px;
  }
  .item__statistic__month {
    color: white;
  }
  .item__statistic__freq {
    font-size: 22px;
    color: white;
    white-space: nowrap;
    color: #529a6d;
  }
}

.bonuses {
  .bonuses__logo {
    font-size: 28px;
    i {
      color: white;
    }
    p {
      color: white;
    }
  }
}
.bonuses__search__area {
  border: 1px solid white;
  display: flex;
  margin-top: 10px;
  padding: 10px;
  i {
    color: black;
    font-size: 25px;
  }
  .bonuses__search {
    width: 60%;
    border-radius: 20px;
    color: white;
    outline: none;
    outline: none;
    border: none;
    border: 1px solid black;
    padding: 20px;
  }
}

.bonuses__amount {
  color: #529a6d !important;
  font-size: 18px;
}

.bonuses__result {
  color: white;
  font-size: 18px;
  margin-bottom: 20px;

  span {
    font-weight: bold;
    font-size: 24px;
  }
  .bonuses__result__text {
    font-size: 14px;
  }
}
::placeholder {
  color: white;
}
.bonuses__list {
  background: #ccc;
  padding: 20px;
  border-radius: 20px;
  width: 50%;
  margin-bottom: 30px;
  outline: none;
  position: relative;
  p {
    color: white;
  }

  .bonuses__right__actions {
    font-size: 24px;
    .mdi-account-edit-outline {
      position: absolute;
      right: 10px;
      top: 10px;
      color: white;
    }
  }
  .bonuses__count {
    width: 25px;
    height: 25px;
    position: absolute;
    right: 10px;
    bottom: 10px;
    font-size: 24px;
    border-radius: 50%;
    border: 1px solid white;
    span {
      font-size: 14px;
    }
  }
  background-image: linear-gradient(
    to right,
    #253532,
    #1e363d,
    #273345,
    #3c2e43,
    #4c2934
  );

  @media (max-width: 900px) {
    width: 100%;
  }
  .bonuses__list__name {
    font-weight: bold;
  }
  .bonuses__delete {
    margin-top: 15px;
    color: white;
    font-weight: bold;
  }
  .bonuses__delete:hover {
    opacity: 0.7;
  }
  .bonuses__list__date {
    width: 200px;
    p {
      white-space: nowrap !important;
      color: white;
    }
  }
}
p {
  margin-bottom: 0;
}
.main__next {
  cursor: pointer;
  background: var(--main-kenes-blue);
  padding: 10px;
  margin-bottom: 20px;
  color: white;
  width: 200px;
  font-weight: bold;
  align-self: center;
  @media (max-width: 900px) {
    width: 100%;
  }
}
.main__next:hover {
  opacity: 0.8;
  color: black;
}

.set__category {
  flex-wrap: wrap;
  .set__category__input {
    width: 500px;
  }
}
.set__category__item {
  border-radius: 4px;
  width: 500px;
  padding: 15px;
  border-radius: 3px;
  margin-bottom: 15px;
  background: white;
  box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 25px -5px,
    rgba(0, 0, 0, 0.04) 0px 10px 10px -5px;
  @media (max-width: 900px) {
    width: 100%;
  }
  .set__category__btn {
    padding: 10px;
    border: 1px solid black;
    color: white;
    background-color: var(--main-kenes-blue);
  }
}

.modal {
  padding: 20px;
  .modal__v {
    width: 150px;

    .modal__round {
      width: 10px;
      height: 10px;
      border-radius: 5px;
    }
  }
}

fieldset {
  border-color: blue !important;
}
.green__message {
  align-items: center;
  .green__input {
    width: 100%;
  }
}
</style>
